import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';

const MOBILE_MAX_WIDTH = 767;

const ChatEmojiPickerPopover = ({ show, onToggle, onClose, onEmojiSelect }) => {
    const [isMobile, setIsMobile] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
        const handleChange = (event) => setIsMobile(event.matches);
        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    useEffect(() => {
        if (!show || !isMobile) {
            return undefined;
        }

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, [show, isMobile]);

    const popover = show ? (
        <div className="chat-emoji-picker-popover-wrap" role="dialog" aria-label="Emoji picker">
            <div className="chat-emoji-picker-popover">
                <Picker data={data} onEmojiSelect={onEmojiSelect} />
            </div>
            {!isMobile ? <span className="chat-emoji-picker-arrow" aria-hidden="true" /> : null}
        </div>
    ) : null;

    const backdrop = show
        ? createPortal(
            <div
                className="chat-emoji-picker-backdrop"
                onClick={onClose}
                aria-hidden="true"
            />,
            document.body
        )
        : null;

    const portaledPopover = show && isMobile && popover
        ? createPortal(popover, document.body)
        : null;

    return (
        <div className="chat-emoji-picker-anchor">
            <div
                className="emoji"
                onClick={onToggle}
                role="button"
                tabIndex={0}
                aria-label="Open emoji picker"
                aria-expanded={show}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        onToggle();
                    }
                }}
            >
                😊
            </div>
            {backdrop}
            {!isMobile && popover}
            {portaledPopover}
        </div>
    );
};

export default ChatEmojiPickerPopover;
